import { api_GET, api_POST, api_PUT } from './_api';

const MTR_api = {
    GetList: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`MTR/GetList`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetImagensMtr: (idMtr) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`MTR/GetImagensMtr/${idMtr}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AtualizaMtr: (mtr) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`MTR/AtualizaMTR`, mtr)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default MTR_api;